/**
 * Copyright (C) Sitevision AB 2002-2024, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-contentlist-portlet')) {
  import(/* webpackChunkName: "contentlist-portlet" */ './contentList-slim');
}
